// extracted by mini-css-extract-plugin
export default {"link":"CategoriesCardsGrid__link--lc-ZVjb6","item_sc":"CategoriesCardsGrid__item_sc--lc-GwcJp"};